import React from 'react';
import { Link } from 'react-router-dom';
import UserInfo from './user/userInfo.jsx';

export default class Header extends React.Component {
    render() {
        return (
            <header className="main-header">
                <Link to="/" className="logo">
                    <span className="logo-mini">
                        <span className="glyphicon glyphicon-envelope"></span>
                    </span>
                    <span className="logo-lg">Мои Посылки</span>
                </Link>
                <nav className="navbar navbar-static-top" role="navigation">
                    <a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
                        <span className="sr-only">Toggle navigation</span>
                    </a>

                    <UserInfo user={this.props.user} />
                </nav>
            </header>
        );
    }
};


// WEBPACK FOOTER //
// ./App/containers/header/header.jsx